import { render, staticRenderFns } from "./ModalPatient.vue?vue&type=template&id=7b5f0246"
import script from "./ModalPatient.vue?vue&type=script&lang=js"
export * from "./ModalPatient.vue?vue&type=script&lang=js"
import style0 from "./ModalPatient.vue?vue&type=style&index=0&id=7b5f0246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports